import React, {useMemo,useState,useEffect} from 'react'
import {useTable, useGlobalFilter,useSortBy, usePagination, useRowSelect,useExpanded } from 'react-table';

// import StockAPI from "./StockAPI.json"
import { MockShortListColumn } from './Columns'; 
import { GlobleFilter } from '../../tableFilter';
import { FaSortDown, FaSortUp, FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight} from "react-icons/fa";
// import { CheckBox } from './CheckBox';
import { Dropdown, Modal } from 'react-bootstrap';
import { FaEllipsisV } from 'react-icons/fa'
// import  {ExpandedDetails} from "./Expand/ExpandedDetails"
import axios from 'axios';
import Cookies from "js-cookie";

import { NODE_API_URL,BASE_URL } from '../../../../env_config';
import ApiDataSkeleton from './ApiDataSkeleton'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SwalWarn } from '../../Popup';
import { withStyles,Switch } from "@material-ui/core";
import teal from "material-ui/colors/teal";

const CustomSwitch = withStyles({
    switchBase: {
      color: teal[300],
      '&$checked': {
        color: teal[500],
      },
      '&$checked + $track': {
        backgroundColor: teal[500],
      },
    },
    checked: {},
    track: {},
  })(Switch);
export const ApiDataLabNew = (props) => {
    const [swalopen,setSwalOpen] = useState(false)
    const [CustomizeTable, setCustomizeTable] = useState(false);
    const handleClose = () => setCustomizeTable(false);
    // const renderRowSubComponent = React.useCallback(
    //     (row) => (
    //         <>
    //             <ExpandedDetails row={row}/>
    //         </>
    //     ),[]
    //   )
    const [update,setUpdate] = useState()
    // const [stockexpire,setStockExpire] = useState([])
    const [erpireddate,setExpiredDate] = useState([])
    const [data,setData] = useState([])
    useEffect(() => {
        props.setMount(!props.mount)

        // const userData = JSON.parse(localStorage.getItem("userData"))
        const finalData = {
            "diamond_type":"L"
        }
        axios({
            method: "get",
            url: `${NODE_API_URL}/INTL/fetch-Supplier-Feed`,
            headers: {
                "Content-Type": "application/json",
                 "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            },
            params: finalData,
        }).then(res => {
            if(res && res.data && res.data.data){
                // setData(res.data.data)
                axios({
                    method: "get",
                    url: `${NODE_API_URL}/INTL/fetch-Supplier-Request`,
                    headers: {
                        "Content-Type": "application/json",
                         "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
                    },
                    params: {
                        "api_id":props.feedsetting.api_id
                    },
                }).then(supreq => {
                    if(supreq && supreq.data && supreq.data.data){
                        // setData(res.data.data)
                        let merged = [];

                        // for (let i = 0; i < supreq.data.data.length; i++) {
                        //     merged.push({
                        //         ...supreq.data.data[i],
                        //         ...(res.data.data.find((itmInner) => itmInner.id === supreq.data.data[i].supplier_id))
                        //     }
                        //     );
                        // }
                        for (let i = 0; i < res.data.data.length; i++) {
                            const fetcheddata = {...(supreq.data.data.find((itmInner) => itmInner.supplier_id === res.data.data[i].id && itmInner.api_id === props.feedsetting.api_id))}
                            merged.push({
                                ...res.data.data[i],
                                ...fetcheddata
                            }
                            );
                        }
                        // console.log(merged,"merged")
                        merged = merged.filter(value => {
                            if(value.supplier_name){
                                return value
                            }
                        })
                        setData(merged,"merged")
                    }
                }).
                catch(error => {
                  if(error?.response?.data?.message === "UnAuthorized!"){
                    var cookies = document.cookie.split(";");
                  for (var i = 0; i < cookies.length; i++) {
                    if(cookies[i] && !cookies[i].includes("view")){
                      var equals = cookies[i].indexOf("=");
                      var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    }
                  }
                  
                  window.location.replace(`${BASE_URL}/logout`);
                }
                })
            }
        }).
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        });
    },[update])
    // console.log(data,"CCMODEDATAAA")
    useEffect(() => {
        let finaloutput = []
        let promises = []
        for(let i = 0;i < data.length; i++){
            promises.push(
                axios({
                    method: "get",
                    url: `${NODE_API_URL}/INTL/fetch-Single-Supplier-Diasense`,
                    headers: {
                        "Content-Type": "application/json",
                         "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
                    },
                    params: {
                        "supp_id":data[i].id
                    },
                }).then(res => {
                if(res && res.data && res.data.data){
                    finaloutput.push({
                        ...data[i],
                        disanceobj:res.data.data
                    })
                }
            }))

        }
        Promise.all(promises).then(() => setExpiredDate(finaloutput)).
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        });
    },[data])
    // console.log(erpireddate,"erpireddate")
    const columns = useMemo(()=> MockShortListColumn(setUpdate,update,erpireddate,toast,props.language,props.userinfo,props.feedsetting),[erpireddate] )
    const {
        getTableProps,
        getTableBodyProps,
        prepareRow,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        pageCount,
        setPageSize,
        setGlobalFilter,
        allColumns,
        getToggleHideAllColumnsProps,
        state:{ globalFilter, pageIndex, pageSize },
    } = useTable({
        columns,
        data
    },
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
        (hooks) =>{
            hooks.visibleColumns.push((columns)=>{
                return[
                    
                    ...columns,
                ]
            })
        }
    )
    const [apistatus,setApiStatus] = useState()
    const TurnOnorOffAll = (api_on_off) => {
        setSwalOpen(true)
        setApiStatus(api_on_off)
        
    }
    const FinalOk = (api_on_off) => {
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/turn-Onor-OffAll`,
            headers: {
                "Content-Type": "application/json",
                 "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            },
            data: {
                api_id:props.feedsetting.api_id,
                type:"Lab Grown",
                api_on_off:api_on_off
            },
        }).then(supreq => {
            if(supreq && supreq.data){
                if(supreq.data){
                setUpdate(supreq.data)
                setSwalOpen(false)

                if(api_on_off === 1){
                    toast.success("Your All Feed Turn on")
                }else{
                    toast.error("Your All Feed Turn Off")
                }
                }
            }
        }).
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
    }
    return (
        <>{!data.length  > 0 ? <ApiDataSkeleton /> : 
                <div>
                  <SwalWarn show={swalopen} message={apistatus === 1?"are you sure you want to turn on all?":"are you sure you want to turn off all?"} onHide={() => setSwalOpen(false)} onClose={() => setSwalOpen(false)} responseOnOk={() => FinalOk(apistatus)}/> 
                    <div className="row">
                        <div className="col-12 mt-3 d-flex justify-content-between">
                            <div className="d-flex align-items-center">
                                <div><GlobleFilter filter={globalFilter} setFilter={setGlobalFilter} /></div>
                            </div>
                            <div className="d-flex align-items-center">
                                <span className="font-weight-bold">Turn Off All</span>
                                <CustomSwitch
                                    checked={props.feedsetting.is_all_labgrown_supplier_on === 1}
                                    onClick={() => props.feedsetting.is_all_labgrown_supplier_on?TurnOnorOffAll(2):TurnOnorOffAll(1)}
                                    // value="perctinclusive"
                                />
                                <span className="font-weight-bold">Turn On All</span>
                            </div>
                        </div>
                        
                        
                        <div className="col-12 pb-0 mt-6">
                                {props.offsupplierlabgrowncount && props.offstonelabgrowncount ? (
                            <div className="alert alert-warning p-3 mb-6 d-flex align-items-center justify-content-between">
                                <div>
                                {props.offsupplierlabgrowncount} supplier{props.offsupplierlabgrowncount !== 1 ? 's' : ''} are off with {props.offstonelabgrowncount} stone{props.offstonelabgrowncount !== 1 ? 's' : ''}. Turn them on?
                                </div>
                                <button className="btn btn-sm btn-primary px-3" onClick={() => FinalOk(1)}>
                                Yes
                                </button>
                            </div>
                            ) : ""}
                            <div className="table-responsive w-100">
                                <table className="table table-hover" {...getTableProps()}>
                                    <thead className="custom_datatable_head" >
                                        {headerGroups.map(headerGroup =>(
                                            <tr {...headerGroup.getHeaderGroupProps()}>
                                                { headerGroup.headers.map((column)=>(
                                                    <th className="text-center align-middle" {...column.getHeaderProps(column.getSortByToggleProps())}>
                                                        {column.render('Header')}
                                                        <span className="text-secondary">
                                                            {column.isSorted ? (column.isSortedDesc ? <FaSortDown /> : <FaSortUp />): ''}
                                                        </span>
                                                    </th>
                                                ))}
                                            </tr>
                                        ))}
                                    </thead>
                                    <tbody {...getTableBodyProps()}>
                                        {page.map((row,i) => {
                                            prepareRow(row)
                                            return(
                                                <React.Fragment key={i}>
                                                    <tr {...row.getRowProps()} key={row.id}>
                                                        {row.cells.map((cell,i) => {
                                                            return <td  className="text-center align-middle" {...cell.getCellProps({ className: cell.column.className})} key={i}>{cell.render('Cell')}</td>
                                                        })}
                                                    </tr>
                                                    {/* {row.isExpanded ? (
                                                        <tr>
                                                            <td className="p-0" colSpan={visibleColumns.length}>
                                                                {renderRowSubComponent({ row })} 
                                                            </td>
                                                        </tr>
                                                    ) : null} */}
                                                </React.Fragment>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="d-flex align-items-center justify-content-between">
                                <span className="table_page_length">Page{' '}{pageIndex + 1 } of {pageOptions.length} {' '}</span>
                                <div>
                                    <button className="btn btn-sm btn-light mr-2" onClick={()=>gotoPage(0) } disabled={!canPreviousPage}><FaAngleDoubleLeft /></button>
                                    <button className="btn btn-sm btn-light mr-2" onClick={() => previousPage()} disabled={!canPreviousPage}><FaAngleLeft /></button>
                                    <span className="font-weight-bold text-muted">{'  '}
                                        <input
                                            className="form-control d-inline-block form-control-sm"
                                            type="number"
                                            value={pageIndex + 1}
                                            // defaultValue={pageIndex + 1}
                                            onChange={ e => { 
                                                const pageNumber=e.target.value ? Number(e.target.value) - 1 : 0
                                                gotoPage(pageNumber)
                                            }}
                                            style={{maxWidth:'70px'}}
                                        />
                                        {'  '}of{'  '} {pageOptions.length}{'  '}
                                    </span>
                                    <button className="btn btn-sm btn-light mr-2" onClick={() => nextPage()} disabled={!canNextPage}><FaAngleRight /></button>
                                    <button className="btn btn-sm btn-light" onClick={()=>gotoPage(pageCount - 1)} disabled={!canNextPage}><FaAngleDoubleRight /></button>
                                </div>
                                <span className="d-flex align-items-center">
                                <span className="text-nowrap page_size">Rows Per page:{' '}</span>
                                    <select className="form-select ml-2 custom-select py-1" value={pageSize} onChange={e => setPageSize(Number(e.target.value))}>
                                        {
                                            [10, 25, 50].map(pageSize => (
                                                <option key={pageSize} value={pageSize}>{pageSize}</option>
                                            ))
                                        }
                                    </select>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                }
                </>
    )
}